module.exports = __webpack_public_path__ + "static/img/hhk.1210bc59.png";